import './Button.css';

function Button({ children, onClick, disabled, variant = 'primary', className = '' }) {
  return (
    <button
      className={`btn btn--${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export default Button;
